import { Chip } from '@material-ui/core'
import Cancel from 'mdi-react/CancelIcon'
import CheckboxMarkedCircleOutlineIcon from 'mdi-react/CheckboxMarkedCircleOutlineIcon'

const CustomChip = ({
  value,
  label,
  style
}: {
  value: string | boolean
  label: string
  style?: any
}) => (
  <Chip
    icon={value ? <CheckboxMarkedCircleOutlineIcon /> : <Cancel />}
    label={label}
    color={value ? 'primary' : 'secondary'}
    style={style}
  />
)

export default CustomChip
